<script>
import IncorporacionAbandono from "./IncorporacionAbandono.vue";
import NochesAdicionales from "./NochesAdicionales.vue";
import TrasladosIncluidos from "./TrasladosIncluidos.vue";

export default {
  components: {
    IncorporacionAbandono,
    NochesAdicionales,
    TrasladosIncluidos,
  },
  data() {
    return {
      opcionesExtra: null,
    };
  },
  methods: {
    actualizarOpcionesExtra(data = null) {
      this.opcionesExtra = data ? Object.assign({}, this.opcionesExtra, data) : data;
      window.activarModoCotizacion();
    },
    async getOrUpdateOpciones(opciones = {}) {
      try {
        const formData = new FormData(document.getElementById("reservar"));
        const params = [...formData.entries()].map(
          (e) => encodeURIComponent(e[0]) + "=" + encodeURIComponent(e[1])
        );
        const response = await fetch(URL_OPC + "?" + params.join("&"), {
          method: "post",
          body: JSON.stringify(opciones),
        });
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }
        const res = await response.json();
        return res;
      } catch (error) {
        console.error(error);
        throw new Error(`No se pudo obtener las opciones extra.`);
      }
    },
  },
};
</script>

<template>
  <div v-if="opcionesExtra">
    <IncorporacionAbandono
      :key="[...opcionesExtra.incorporacionesCircuito, ...opcionesExtra.abandonosCircuito].map(i => i.fecha).join('-')"
      :incorporaciones="opcionesExtra.incorporacionesCircuito"
      :abandonos="opcionesExtra.abandonosCircuito"
      @update="actualizarOpcionesExtra"
    />
    <NochesAdicionales
      :key="opcionesExtra.nochesAdicionalesCircuito.map(n => n.idServicioCarga).join('-')"
      :nochesAdicionales="opcionesExtra.nochesAdicionalesCircuito"
      @update="actualizarOpcionesExtra"
    />
    <TrasladosIncluidos
      :key="opcionesExtra.trasladosIncluidosCircuito.map(n => n.idServicioCarga).join('-')"
      :trasladosIncluidos="opcionesExtra.trasladosIncluidosCircuito"
      @update="actualizarOpcionesExtra"
    />
  </div>
</template>

<style lang="scss"></style>
